{
  "fr": {
    "aiImage": {
      "confirm": {
        "deleteImage": {
          "text": "Cette action est irréversible. L'image sera définitivement supprimée de votre historique.",
          "title": "Supprimer l'image ?"
        },
        "moveAllToTrash": {
          "text": "Toutes les images seront supprimées de votre historique. Vous les retrouverez ensuite dans la corbeille.",
          "title": "Déplacer les images vers la corbeille ?"
        }
      },
      "errors": {
        "generationFailed": "Échec de la génération d'image. Veuillez réessayer.",
        "generationTimeout": "La génération d'images prend anormalement longtemps et a été annulée. Veuillez réessayer.",
        "loadFailed": "L'image n'a pas pu être chargée. Elle a peut-être été supprimée ou vous n'y avez pas accès.",
        "rateLimitExceeded": "Vous avez créé trop d'images en peu de temps. Veuillez patienter un moment et réessayer."
      },
      "headers": {
        "form": "Créer une image personnalisée",
        "proposals": "Suggestions"
      },
      "hints": {
        "progressMessage": "Image en cours de génération..."
      },
      "imageStyles": {
        "concept_art": "Art conceptuel",
        "custom": "Standard",
        "drawing": "Dessin",
        "graphics_3d": "Graphique 3D",
        "origami": "Origami",
        "painting": "Peinture",
        "photo": "Photo",
        "polaroid": "Polaroid"
      },
      "labels": {
        "copyPrompt": "Copier le prompt",
        "create": "Créer une image",
        "createdAt": "Créé le",
        "imageSize": "Taille de l'image",
        "imageStyle": "Style",
        "model": "Modèle",
        "openImageInNewTab": "Ouvrir l'image dans un nouvel onglet",
        "prompt": "Prompt",
        "promptDescribe": "Décrire l'image",
        "provider": "Fournisseur",
        "providerInfo": "Plus d'informations",
        "result": "Résultat",
        "size": "Taille"
      },
      "messages": {
        "allMovedToTrash": "Toutes les images ont été déplacées dans la corbeille",
        "deleted": "Image supprimée"
      },
      "prompts": {
        "prompt1": "Photo d'une coccinelle vue de dessus, posée sur une tige d'herbe verte dans une prairie ensoleillée. La coccinelle a des ailes rouges vives avec des points noirs. En arrière-plan, des fleurs floues et un ciel bleu clair sont visibles. La scène est lumineuse et vivante, avec un focus sur la coccinelle.",
        "prompt2": "Portrait photoréaliste d'une jeune étudiante en ingénierie aux cheveux noirs courts, regardant rêveusement par une grande fenêtre dans un bâtiment universitaire moderne. La lumière douce et chaude du jour illumine la scène, et la caméra est positionnée à hauteur des yeux. En arrière-plan, des étagères floues et des dessins techniques ajoutent une atmosphère académique et inspirante.",
        "prompt3": "Peinture impressionniste d'un homme d'âge moyen marchant avec un parapluie noir sous une tempête, le long de la rive d'une rivière tumultueuse. La scène est représentée avec des coups de pinceau doux et fluides capturant le mouvement du vent et de la pluie. Le ciel est peint en nuances dramatiques de gris, tandis que la rivière scintille en tons profonds de bleu et de vert. L'homme porte un long manteau sombre qui flotte dans le vent, et les couleurs de son manteau et de son parapluie sont légèrement floues pour accentuer l'intensité de la tempête."
      },
      "tooltips": {
        "generatePrompt": "Optimiser le prompt",
        "generatePromptDisabled": "Entrez d'abord un prompt pour l'optimiser"
      },
      "views": {
        "new": {
          "labels": {
            "imageStyle": "Choisir un style"
          }
        }
      }
    }
  }
}
